import useViewport from "./useViewport";

function useFormatImage({ image }) {
    const { isDesktop } = useViewport();
    const key = isDesktop ? 'url' : '_url';
    return image?.[key] || '';
}

export default useFormatImage;